import { SET_HAS_REFERENCE_DATA } from '../actions/hasReferenceDataActions';

let initialState = false;

const hasReferenceDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_HAS_REFERENCE_DATA:
            return action.payload.value
        default:
            return state;
    }
}

export default hasReferenceDataReducer;